import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ResultResponse } from 'src/app/view-models/lms.models';

@Component({
  selector: 'app-assessment-summary',
  templateUrl: './assessment-summary.component.html'
})
export class AssessmentSummaryComponent implements OnInit {
  attemptId!: number;
  result!: ResultResponse;
  isLoading: boolean = true;
  apiError: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.attemptId = parseInt(idParam, 10);
      this.loadResult();
    }
  }

  loadResult(): void {
    this.apiService.getAssessmentResult(this.attemptId).subscribe({
      next: (res) => {
        this.result = res;
        this.isLoading = false;
      },
      error: (err) => {
        this.apiError = 'Failed to load assessment results. Please try again.';
        this.isLoading = false;
      }
    });
  }

  getBadgeText(): string {
    if (this.result.status === 'cleared') return 'Completed';
    if (this.result.status === 'not_cleared' && this.result.can_retake) return 'Retake available';
    return 'Failed';
  }

  getBadgeClass(): string {
    if (this.result.status === 'cleared') return 'bg-[#E9F0E6] text-[#1A5C3D]';
    if (this.result.status === 'not_cleared' && this.result.can_retake) return 'bg-[#FEF3EB] text-[#B95000]';
    return 'bg-[#FBE9E9] text-[#D92D20]';
  }

  startRetake(): void {
    // Navigating back to start creates a new attempt via the key
    this.router.navigate(['/techsure/take', this.result.assessment_key]);
  }

  goBackToAssessments(): void {
    this.router.navigate(['/techsure/assessments']);
  }
}